import { useEffect } from "react";

interface Props {
  mainArea: server.dto.MainAreas
  onClose: () => void
}

const ClientFileDownloadAll = (props: Props) => {
  useEffect(() => {
    window.location.href = window.CoreApi.MySelection.ExportMyClientFileSelectionInZip.absoluteUrl(`${RESX.File.Download}.zip`);
    props.onClose();
  }, []);

  return null;
};

export default ClientFileDownloadAll;